export const permissionGroupFormFields = [
  {
    id: "id",
    dataType: "integer",
    shownOnForm: false,
    label: "ID",
    value: 0,
    isRequired: false,
    fieldType: "textfield",
  },
  {
    id: "name",
    dataType: "Text",
    shownOnForm: true,
    label: "Name",
    value: "",
    isRequired: true,
    maxChar: 255,
    fieldType: "textfield",
  },
  {
    id: "description",
    dataType: "Text",
    shownOnForm: true,
    label: "Description",
    value: "",
    isRequired: false,
    maxChar: 255,
    fieldType: "textarea",
  },
  {
    id: "permissions",
    dataType: "Array",
    shownOnForm: true,
    isRequired: true,
    label: "Permission",
    value: [],
    fieldType: "multiselect",
    textValue: "name",
    options: ({ permissions }) => permissions || [],
  },
];

export const permissionGroupRecord = {
  id: 0,
  name: "",
  description: "",
  permissions: [],
};
